import {Selector, createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';
import {ITableReportSliceState} from '../table-report-slice-types';

const rootSelector: Selector<TAppState, ITableReportSliceState> = (state: TAppState) => state[TABLE_REPORT_SLICE];

export const selectTableReportLocalSearch = createSelector(rootSelector, ({localSearch}) => localSearch);

export const selectTableReportSelectedCellIndexes = createSelector(rootSelector, ({localSearch}) => {
    const {currentSelection, results, count} = localSearch;
    if (currentSelection === null || count === null) return null;
    return results?.[currentSelection] ?? null;
});

export const selectTableReportGlobalSearchIsLoading = createSelector(
    rootSelector, ({globalSearch}) => globalSearch.isLoading,
);
export const selectTableReportGlobalSearch = createSelector(rootSelector, ({globalSearch}) => globalSearch);
export const selectTableReportGlobalPages = createSelector(rootSelector, ({globalSearch}) => globalSearch.pages);
export const selectTableReportGlobalSearchLine = createSelector(rootSelector, ({globalSearch}) => globalSearch.line);
export const selectTableReportGlobalSearchCurrentPage = createSelector(rootSelector, (
    {globalSearch},
) => globalSearch.currentPage);
